//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DivSpan from '@/components/DivSpan';
import searchInput from '@/components/search-input';
import fileUpload from '@/components/file-upload';
import claimTp from '@/components/page-temporary/claimTp'
export default {
  name: "claim-management-list",
  components: {DivSpan, searchInput, fileUpload, claimTp},
  data() {
    return {
      tabIndex: 1,
      wrapperHeight: 0,
      allLoaded: false,
      config: {
        title: '费用管理',
        url: 'api/claim-dt/page',
        workflowSearchBean: {},
        tabList:['查询费用','费用待办'],
        property: "claim.createdDate",
        fixRules: [],
        inputCondition: {
          placeholder: '费用单号/供应商名称',
          searchCondition: 'key',
          rules: [{field: "claim.docNo-claim.supplier.supplierName-claim.supplier.supplierCode", option: "LIKE_ANYWHERE"}]
        },
        selectConfig: [
          {
            text: '流程状态',
            type: 'selector',
            list: [
              {name:'全部',code:'',selected:true},
              {name:'草稿',code:'0'},
              {name:'审批中',code:'1'},
              {name:'审批完成',code:'2'}
            ],
            rules: [{field: "claim.requestBase.currentNodeType", option: "IN"}],
          },
          {
            text: '费用分类',
            type: 'selector',
            list: [
              {name:'全部',code:'',selected:true}
            ],
            rules: [{field:"scType",option: "IN"}],
          },
          {
            text: '关闭状态',
            type: 'selector',
            list: [
              {name:'全部',code:'',selected:true},
              {name:'未关闭',code:'0'},
              {name:'已关闭',code:'1'}
            ],
            rules: [{field:"open",option: "IN"}],
          }
        ]
      },
      configTodo: {
        title: '费用管理',
        url: 'api/claim-dt/page',
        workflowSearchBean: {},
        tabList:['查询费用','费用待办'],
        property: "claim.createdDate",
        fixRules: [],
        inputCondition: {
          placeholder: '费用单号/供应商名称',
          searchCondition: 'key',
          rules: [{field: "claim.docNo-claim.supplier.supplierName-claim.supplier.supplierCode", option: "LIKE_ANYWHERE"}]
        },
        selectConfig: [
          {
            text: '流程状态',
            type: 'selector',
            list: [
              {name:'全部',code:'',selected:true},
              {name:'草稿',code:'0'},
              {name:'审批中',code:'1'},
              {name:'审批完成',code:'2'}
            ],
            rules: [{field: "claim.flowState", option: "IN"}],
          },
          {
            text: '费用分类',
            type: 'selector',
            list: [
              {name:'全部',code:'',selected:true}
            ],
            rules: [{field:"scType",option: "IN"}],
          },
          {
            text: '关闭状态',
            type: 'selector',
            list: [
              {name:'全部',code:'',selected:true},
              {name:'未关闭',code:'0'},
              {name:'已关闭',code:'1'}
            ],
            rules: [{field:"open",option: "IN"}],
          }
        ]
      },
      searchData: {},
      list: [],
      showMore: true
    }
  },
  methods: {
    getTabIndex(e) {
      this.tabIndex = e;
      this.showMore=false;
      this.$nextTick(() => {
        this.showMore=true;
      })
    },
    goDetail(data){
      this.$router.push('/workflow/'+data.claim.requestId+'?component=ClaimViewComponent')
    },
    getList(e,met,bol){
      this.$nextTick(()=>{
        if(bol){
          this.list = this.list.concat(e);
        }else{
          this.list = e;
        }
        if(met === 'top'){
          this.$refs.loadmore.onTopLoaded();
        }
        if(met === 'bottom'){
          this.$refs.loadmore.onBottomLoaded();
        }
      })
    },
    init: function () {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
    },
    loadTop() {
      this.$refs.header.getlist(true);
    },
    loadBottom() {
      this.$refs.header.getMore();
    },
    getTypeList(){
      this.$get('api/dict-tables/search-with-list?dictCode=quesType').then(data => {
        console.log("ziduan", data)
        data.dictItems.forEach(item => {
          this.config.selectConfig[1].list.push({
            name: item.value,
            code: item.code
          });
          this.configTodo.selectConfig[1].list.push({
            name: item.value,
            code: item.code
          })
        })
        
      })
    },
    getWorkFlow() {
      this.$get('api/biz-object-parameters/key/claimManagement').then(data => {
        this.config.workflowSearchBean = {
          workflowId: data.workflowType
        };
        this.configTodo.workflowSearchBean = {
          workflowId: data.workflowType,
          searchKey: "claim.id",
          searchType: "0"
        };
        this.$refs.header.getlist();
      })
    },
  },
  mounted() {
    this.init();
    this.getTypeList();
    this.$refs.header.tabIndex = this.$route.query.tabIndex || 1;
    this.tabIndex = this.$route.query.tabIndex || 1;
    this.userType = this.$route.query.userType || 1;
    this.tabList = this.userType == 0?['查询我的扣款', '我的扣款待办']:['查询费用','费用待办'];
    this.$nextTick(()=>{
      this.config.tabList = this.configTodo.tabList = this.tabList;
    });
    this.getWorkFlow();
  }
}



// WEBPACK FOOTER //
// ./src/page/claim-management/claim-management-list.vue